<template>
    <footer class="footer">
        <h5>&copy; Secretaria Municipal de Saúde Pública - Campo Grande - MS, {{ ano }}</h5>
    </footer>
</template>

<script>
    export default {
        data () {
            return {
                ano: new Date().getFullYear()
            }
        }
    }
</script>

<style>
.footer {
    background-color: #255e8bc2;
    color: #e8e8e8;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 1.4rem;
}

footer h5 {
    font-size: 0.8rem;
}
</style>

